// formValidations.js

export const numberValidation = {
    required: "This field is required",
    pattern: {
        value: /^[0-9]+$/,
        message: "Only numbers are allowed",
    },
};

export const decimalValidation = {
    required: "This field is required",
    pattern: {
        value: /^\d+(\.\d+)?$/,
        message: "Only valid decimal numbers allowed",
    },
};

export const requiredValidation = {
    required: "This field is required",
};
export const noSpaceOnlyValidation = {
    validate: (value) =>
        value === "" || value.trim() !== "" || "Field cannot contain only spaces",
};

export const phoneValidation = {
    pattern: {
        value: /^[0-9]{10}$/,
        message: "Enter a valid 10-digit mobile number",
    },
};

export const emailValidation = {
    pattern: {
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        message: "Please enter a valid email",
    },
};

export const passwordMinLengthValidation = {
    minLength: {
        value: 6,
        message: "Password must be at least 6 characters long",
    }
}

export const positiveNumberValidation = {
    valueAsNumber: true,
    min: {
        value: 1,
        message: "Value must be greater than 0",
    },
};

export const nonNegativeNumberValidation = {
    valueAsNumber: true,
    min: {
        value: 0,
        message: "Value cannot be negative",
    },
};

export const nonZeroValidation = {
    valueAsNumber: true,
    validate: (value) =>
        value !== 0 || "Amount cannot be zero",
};

export const siteNameValidation = {
    validate: (value) => {
        if (value.trim() === "") {
            return "Site Name cannot be empty or only spaces";
        }
        if (value !== value.trim()) {
            return "Please remove spaces at the beginning or end";
        }
        if (value.includes(".")) {
            return "Site Name cannot include a period (.)";
        }
        return true;
    },
};

export const aadharNumberValidation = {
  required: "Please enter Aadhaar number",
  pattern: {
    value: /^\d{12}$/,
    message: "Aadhaar number must be exactly 12 digits",
  },
};

export const panNumberValidation = {
  required: "Please enter PAN card number",
  pattern: {
    value: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
    message: "Please enter a valid PAN card number",
  },
};